<div
  #matTooltip="matTooltip"
  (mouseleave)="!!tooltip ? matTooltip.hide() : ''"
  *ngIf="!!tooltip && tooltip.length > 0"
  [matTooltip]="tooltip"
  class="tooltip-container"></div>
